/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Fact_3_LInputs */

const en_cp_fact_3_l = /** @type {(inputs: Cp_Fact_3_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`client viewer, approve phases`)
};

const id_cp_fact_3_l = /** @type {(inputs: Cp_Fact_3_LInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`client viewer, setujui fase`)
};

/**
* | output |
* | --- |
* | "client viewer, approve phases" |
*
* @param {Cp_Fact_3_LInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_fact_3_l = /** @type {((inputs?: Cp_Fact_3_LInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Fact_3_LInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_fact_3_l(inputs)
	return en_cp_fact_3_l(inputs)
});